import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
var history = new Swiper(".section2 .mySwiper", {
    slidesPerView: 5,
    spaceBetween: 20,
    navigation: {
        nextEl: ".section2  .swiper-button-next",
        prevEl: ".section2  .swiper-button-prev",
    },
    breakpoints: {
      1280: {  //当屏幕宽度小于等于1280
        slidesPerView: 5,
        spaceBetween: 20,
      },
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 3,
        spaceBetween: 20,
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 1,
        spaceBetween: 0,
      }
    } 
});

$(".section4 .pic img").eq(0).addClass("active");
$(".section4 ul li").hover(function() {
  let index = $(this).index();
  $(".section4 .pic img").eq(index).addClass('active').siblings().removeClass('active');
})

$(document).ready(function() {
  // 获取所有的 li
  var allItems = $('#itemList li');
  // 总数量
  var totalCount = allItems.length;
  // 当前显示到第几个
  var currentIndex = 0;
  // 每次加载的数量
  var step = 3;
  // 默认显示的数量
  var defaultShow = 7;
  
  // 初始化：先显示前6个
  function initDisplay() {
    // 先隐藏所有
    allItems.hide();
    // 显示前6个
    allItems.slice(0, defaultShow).show();
    currentIndex = defaultShow;
    
    // 如果总数量小于等于默认显示数量，直接隐藏按钮
    if (totalCount <= defaultShow) {
      $('#loadMoreBtn').hide();
    }
  }
  
  // 调用初始化
  initDisplay();
  
  // 点击加载更多按钮
  $('#loadMoreBtn').on('click', function() {
    // 计算这次要显示到第几个
    var nextIndex = Math.min(currentIndex + step, totalCount);
    
    // 显示从 currentIndex 到 nextIndex 的 li
    allItems.slice(currentIndex, nextIndex).slideDown();
    
    // 更新当前索引
    currentIndex = nextIndex;
    
    // 如果已经全部显示，隐藏按钮
    if (currentIndex >= totalCount) {
      $(this).hide();
    }
  });
});

var swiper2 = new Swiper(".section7 .mySwiper2", {
    
});
var swiper = new Swiper(".section7 .mySwiper", {
    navigation: {
        nextEl: ".section7  .swiper-button-next",
        prevEl: ".section7  .swiper-button-prev",
    },
    thumbs: {
        swiper: swiper2,
    },

});
